import { Provider } from '../../@types';

class AdyenProvider implements Provider {
  createProvider() {
    throw new Error('Not implemented');
  }
}

const provider = new AdyenProvider();

export { provider };
